import commonGetters from '../commons/getters'
export default {
    ...commonGetters
}